import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "41",
  height: "41",
  fill: "none",
  viewBox: "0 0 41 41"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "36",
      height: "36",
      x: "2.519",
      y: "2.032",
      fill: "#24A1DE",
      rx: "6"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M12.089 18.906q7.872-3.429 10.497-4.521c4.998-2.08 6.037-2.44 6.714-2.453.15-.002.482.037.698.21.182.148.232.347.256.487q.056.353.03.709c-.271 2.846-1.443 9.755-2.04 12.941-.251 1.349-.748 1.8-1.23 1.846-1.043.096-1.838-.691-2.851-1.355-1.584-1.038-2.479-1.685-4.017-2.698-1.777-1.171-.625-1.815.388-2.867.265-.275 4.87-4.464 4.96-4.844.01-.048.021-.225-.084-.319-.106-.093-.26-.061-.373-.036q-.239.054-7.592 5.019-1.079.74-1.952.72c-.643-.014-1.88-.364-2.799-.663-1.127-.366-2.023-.56-1.944-1.182q.06-.485 1.339-.994",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }